import { useEffect, useRef } from 'react';
export const useDefaultValueValidation = (formContext, name) => {
  const initial = useRef(false);
  const value = formContext.getValues(name);
  useEffect(() => {
    if (value !== undefined && !initial.current) {
      formContext.trigger(name);
      initial.current = true;
    }
  }, [formContext, name, value]);
};